const CHANGE_PASSWORD_DIALOG_STATES = {
  USER: 'User',
  ADMIN: 'Admin',
  NONE: false,
};

/**
 * An error message shown when the current password provided is invalid
 * @type {string}
 */
const CURRENT_PASSWORD_INCORRECT = 'Current Password is incorrect.';

/**
 * An enumeration of different errors for the change password dialog.
 * @type {Object}
 */
const CHANGE_PASSWORD_ERRORS = {
  CURRENT_PASSWORD_INCORRECT,
};

export { CHANGE_PASSWORD_DIALOG_STATES, CHANGE_PASSWORD_ERRORS };
